const css = `
.modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.8);backdrop-filter:blur(8px);
  display:flex;align-items:center;justify-content:center;z-index:200;padding:20px;}
.modal-box{background:#111C2E;border:1px solid rgba(0,194,255,0.2);border-radius:16px;
  width:100%;max-width:520px;max-height:90vh;overflow-y:auto;padding:30px;}
.modal-title{font-family:'Barlow Condensed',sans-serif;font-size:26px;font-weight:800;margin-bottom:4px;}
.modal-sub{font-size:13px;color:#8899AA;margin-bottom:24px;}
.modal-actions{display:flex;gap:10px;margin-top:24px;}
.modal-actions .btn{flex:1;}
`;
export default function Modal({ title, sub, onClose, children }) {
  return (<><style>{css}</style>
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e=>e.stopPropagation()}>
        {title && <div className="modal-title">{title}</div>}
        {sub   && <div className="modal-sub">{sub}</div>}
        {children}
      </div>
    </div></>);
}
